export default [
    { //孵化器列表
        path: '/incubatorManagement/incubatorList',
        name:'incubatorManagementIncubatorList',
        meta: { title: '孵化器列表'},
        component: () => import('../../views/incubatorManagement/incubatorList.vue')
    },
    { //孵化器明细
        path: '/incubatorManagement/incubatorDetail',
        name:'incubatorManagementIncubatorDetail',
        meta: { title: '孵化器明细'},
        component: () => import('../../views/incubatorManagement/incubatorDetail.vue')
    },
    { //入驻企业
        path: '/incubatorManagement/settledEnterprise',
        name:'incubatorManagementEettledEnterprise',
        meta: { title: '入驻企业'},
        component: () => import('../../views/incubatorManagement/settledEnterprise.vue')
    },
]